/**
 * AppSync answers with a PARTIAL result when a nested field is unauthorized (e.g. an org member reaching a
 * composed forecast that has no organizationId). Amplify v6 still throws, with the readable part on error.data.
 * Return that part so one unreadable nested record drops out instead of failing the whole query; anything else
 * (network, a root field missing) is rethrown.
 *
 * `rootField` is the top-level field the caller needs, e.g. "geoPointsByAssetGroupIdAndName".
 */
export function partialGraphqlData<T>(error: unknown, rootField: string, label: string): T {
  const data = (error as { data?: Record<string, unknown> } | null)?.data;
  if (data && data[rootField]) {
    const paths = ((error as { errors?: { path?: unknown[] }[] }).errors ?? []).map((e) => e.path?.join("."));
    console.warn(`${label}: partial result, some nested records not readable`, paths);
    return data as T;
  }
  throw error;
}
